import { CoachOptions } from './CoachOptions';

// A single coach/user message. Bubble body is rendered via dangerouslySetInnerHTML
// because the protocol intentionally supports inline rich HTML (citations as
// <em class='cite'>, blockquotes, spawn cards). Production must sanitize via
// DOMPurify before any real LLM streams into text_html — see BACKEND.md.

export function CoachMessage({ message, pickedKey, onPick, onCta }) {
  const isCoach = message.who === 'coach';
  return (
    <div className="flex gap-2.5 min-w-0 px-3 py-2.5">
      <div
        className={[
          'flex-none w-[22px] h-[22px] mt-0.5 grid place-items-center border border-ink font-mono text-[10px]',
          isCoach ? 'bg-ink text-paper' : 'bg-accent-soft text-ink',
        ].join(' ')}
      >
        {isCoach ? 'C' : 'MH'}
      </div>

      <div className="flex-1 min-w-0 max-w-full font-sans text-[13.5px] leading-[1.5] text-ink [overflow-wrap:anywhere] break-words">
        {message.time && (
          <div className="font-mono text-[10px] tracking-[0.04em] text-ink-4 mb-0.5">
            {message.time} · {message.who}
          </div>
        )}

        <span
          className="coach-bubble"
          dangerouslySetInnerHTML={{ __html: message.text_html }}
        />

        {message.options && (
          <CoachOptions options={message.options} pickedKey={pickedKey} onPick={onPick} />
        )}

        {message.cta && (
          <button
            type="button"
            onClick={() => onCta?.(message.cta.hub_slug)}
            className="mt-2 underline underline-offset-[3px] font-sans text-[13.5px] text-ink hover:text-accent-ink"
          >
            {message.cta.label}
          </button>
        )}
      </div>
    </div>
  );
}

export default CoachMessage;
